import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-brand-green/20 last:border-0" data-id="element-69">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full text-left py-5 flex justify-between items-center focus:outline-none group" data-id="element-70">
        <h4 className="text-base md:text-lg font-serif font-bold text-brand-charcoal group-hover:text-brand-green transition-colors pr-4" data-id="element-71">
          {question}
        </h4>
        <div className={`ml-4 flex-shrink-0 w-6 h-6 rounded-full border border-brand-green flex items-center justify-center transition-transform duration-300 ${isOpen ? 'bg-brand-green text-white rotate-180' : 'text-brand-green'}`} data-id="element-72">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-73">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-74" />
          </svg>
        </div>
      </button>
      <AnimatePresence data-id="element-75">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-76">
            <p className="pb-5 text-brand-charcoal/80 leading-relaxed" data-id="element-77">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export function FAQSection() {
  const faqs = [{
    question: '¿Tengo que comprar suplementos caros?',
    answer: 'No. Te enseñamos cuáles funcionan, pero la base es la nutrición informativa que compras en cualquier super.'
  }, {
    question: '¿Funciona si ya pasé la menopausia?',
    answer: 'Sí, los principios de resiliencia metabólica son vitales para la salud ósea y cardiovascular post-menopausia.'
  }, {
    question: '¿Cuánto tiempo necesito al día?',
    answer: 'Entre 15 y 30 minutos al día son suficientes para aplicar los protocolos. Las recetas están diseñadas para prepararse en 15 minutos o menos, y las rutinas de movimiento no superan los 20 minutos.'
  }, {
    question: '¿Es solo un PDF o hay más formatos?',
    answer: 'Recibes el ebook principal en PDF junto con 15 guías y herramientas adicionales (checklists, recetarios, protocolos, diarios de seguimiento). Todo está diseñado para ser práctico y fácil de seguir desde el primer día.'
  }, {
    question: '¿Funciona si tomo medicación?',
    answer: 'El sistema se basa en nutrición, hábitos y gestión del estrés — no reemplaza ningún tratamiento médico. Es perfectamente compatible con medicación. Siempre recomendamos consultar con tu médico ante cualquier duda específica.'
  }, {
    question: '¿Puedo acceder desde el móvil?',
    answer: 'Sí, todo el contenido es digital y accesible desde cualquier dispositivo: móvil, tablet u ordenador. Puedes leerlo donde y cuando quieras.'
  }];
  return <section className="py-8 px-4 md:px-8 bg-brand-creamAlt" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-80">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal text-center mb-8" data-id="element-81">
            Preguntas Frecuentes
          </h2>

          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-82">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-83" />)}
          </div>
        </motion.div>
      </div>
    </section>;
}